const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/item-types/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@tempo-io/sui-spinner';
import { requirePermission } from '@/common/hooks/usePermissions';
import { itemTypeLevelsQueryOptions } from '@/common/queries/useItemTypeLevelsQuery';
import { itemTypesQueryOptions } from '@/common/queries/useItemTypesQuery';
import i18n from '@/common/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/item-types/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: requirePermission('edit_integrations'),
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await Promise.all([queryClient.ensureQueryData(itemTypesQueryOptions()), queryClient.ensureQueryData(itemTypeLevelsQueryOptions())]);
    return {
      crumb: i18n.t($ => $.common.settings.itemTypes.itemTypes)
    };
  },
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.itemTypes.itemTypes)
    }
  }
});